"use strict";

import { AppDispatcher } from 'Dispatcher';
import { TreeListConstants } from 'Constants/TreeListConstants';
export function tlSetStore(options) {
  AppDispatcher.dispatch({
    actionType: TreeListConstants.TREE_VIEW_SET_STORE,
    options: options
  });
}
export function tlDestroyStore(UUID) {
  AppDispatcher.dispatch({
    actionType: TreeListConstants.TREE_VIEW_DESTROY_STORE,
    UUID: UUID
  });
}
export function tlUpdateUuid(prev, next) {
  AppDispatcher.dispatch({
    actionType: TreeListConstants.TREE_VIEW_UPDATE_UUID,
    next: next,
    prev: prev
  });
}